import React from "react";
import "./Footer.css"; // Styles will be in a separate CSS file

const Footer = () => {
  const phoneNumber = '+818084985629';
  const message = 'I want this vehicle';
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section">
          <h3>About Us</h3>
          <p>
            SKC Japan is your trusted partner for high-quality used vehicles from Japan. We strive to deliver excellence with every car, ensuring top-notch service and customer satisfaction.
          </p>

          <a
            href={whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              position: 'fixed',
              bottom: '20px',
              left: '20px',
              zIndex: 1000,
              backgroundColor: '#25D366',
              borderRadius: '50%',
              width: '60px',
              height: '60px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
              textDecoration: 'none',
            }}
            aria-label="Contact us on WhatsApp"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="30"
              height="30"
              viewBox="0 0 24 24"
              fill="#fff"
            >
              <path d="M12 0C5.373 0 0 5.373 0 12c0 2.133.558 4.134 1.533 5.873L0 24l6.308-1.614A11.943 11.943 0 0012 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm3.463 16.894c-.338.955-1.973 1.834-2.773 1.955-.747.112-1.695.057-3.215-.673-2.727-1.313-4.468-3.955-4.605-4.125-.135-.169-1.103-1.447-1.103-2.762 0-1.315.695-1.966 1.033-2.247.338-.281 1.103-.281 1.441-.281.338 0 .676.056.957.281.281.225.563.675.676 1.103.112.45.225.9.225 1.103 0 .225-.112.563-.225.788-.112.225-.225.45-.225.676 0 .225.112.45.338.563.225.112.563.225.9.338.338.112.676.225 1.013.337.338.112.676.281.957.506.281.225.563.506.676.844.112.338.225.788.225 1.315 0 .563-.225 1.125-.563 1.575-.338.45-.9.788-1.463 1.013z" />
            </svg>
          </a>
          
        </div>

        <div className="footer-section">
          <h3>Quick Links</h3>
          <ul>
            <li><a href="/home">Home</a></li>
            <li><a href="/company-profile">About</a></li>
            <li><a href="/inventory">Inventory</a></li>
            <li><a href="/how-to-buy">How to buy</a></li>
            <li><a href="/contact">Contact</a></li>
          </ul>
        </div>

        <div className="footer-section">
          <h3>Contact Us</h3>
          <p><i className="fas fa-map-marker-alt"></i> 1-18-11, OJIMA, KOTO KU, TOKYO, JAPAN 136-0072</p>
          <p><i className="fas fa-phone"></i> +81-345-888-721</p>
          <p><i className="fas fa-envelope"></i> info@skcjapan.com</p>
        </div>

        <div className="footer-section">
          <h3>Follow Us</h3>
          <div className="social-icons">
            <a href="https://www.facebook.com/Skcjapanofficial/" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-facebook-f"></i>
            </a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-twitter"></i>
            </a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-instagram"></i>
            </a>
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-linkedin-in"></i>
            </a>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <p>Develoved by &copy; {new Date().getFullYear()} <a style={{color:"#ffffff"}} href="https://dotlocalhost.com/" target="_blank">DotLocalhost</a>. All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;